import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const RazonSocialFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='RAZON SOCIAL' htmlFor='input-razonSocial' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Field name='razonSocial'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-razonSocial'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(RazonSocialFormGroup)
